import { BASE_URL } from "@constants/api.constants";
import { APP } from "@constants/app.constants";
import { uploadImageFile } from "@utils/upload.util";
const { STATUS } = APP;
export const getInventoryItemsInputs = (categories, manufacturers, initialValues) => [
  
  {
    groupName: "Inventory",
    type: "SELECT",
    label: "Category",
    id: "category_id",
    name: "category_id",
    value: initialValues?.category_id || "",
    options: categories,
    placeholder: "Select the Category ",
    validations: [
      {
        type: "REQUIRED",
        message: "Category is required !",
      },
    ],
  },
  {
    groupName: "Inventory",
    type: "TEXT",
    label: "Part Number",
    id: "part_number",
    name: "part_number",
    value: initialValues?.part_number || "",
    placeholder: "Enter the Part Number",
    validations: [
      {
        type: "REQUIRED",
        message: "Part Number is required !",
      },
    ],
  },
  {
    groupName: "Inventory",
    type: "SELECT",
    label: "Make",
    id: "make",
    name: "make",
    value: initialValues?.manufacturer_name || "",
    options: manufacturers,
    placeholder: "Select Make",
    validations: [
      {
        type: "REQUIRED",
        message: "Make is required !",
      },
    ],
  },
  {
    groupName: "Inventory",
    type: "TEXT",
    label: "Date Code",
    id: "date_code",
    name: "date_code",
    value: initialValues?.date_code || "",
    placeholder: "Enter Date Code",
  },
  {
    groupName: "Inventory",
    type: "TEXT",
    label: "Source",
    id: "source",
    name: "source",
    value: initialValues?.source || "",
    placeholder: "Enter Source",
  },
  { 
    groupName: "Inventory",
    type: "TEXT",
    label: "Available Quantity",
    id: "available_qty",
    name: "available_qty",
    value: initialValues?.available_qty || "",
    placeholder: "Enter Available Quantity",
    validations: [
      {
        type: "REQUIRED",
        message: "Available Quantity is required !",
      },
    ],
  },

  {
    groupName: "Inventory",
    type: "TEXT",
    label: "Lead Time",
    id: "lead_time",
    name: "lead_time",
    value: initialValues?.lead_time || "",
    placeholder: "Enter Lead Time",
  },
  {
    groupName: "Inventory",
    type: "TEXT",
    label: "MPQ",
    id: "mpq",
    name: "mpq",
    value: initialValues?.mpq || "",
    placeholder: "Enter MPQ",
  },
  {
    groupName: "Inventory",
    type: "FILE_UPLOAD",
    label: "Image",
    id: "image",
    name: "image",
    value: initialValues?.image || "",
    filePrefix: BASE_URL + "app-source/images/",
    handleSelfUpload: uploadImageFile,
    validations: [],
  },
  {
    groupName: "Inventory",
    type: "SELECT",
    label: "Status",
    id: "status",
    name: "status",
    options: STATUS ,
    value: initialValues?.status || "1",
    placeholder: "Select status",
  },

  {
    groupName: "Price",
    // groupClass: "col-md-12",
    type: "FORM_REPEATER",
    validations: [],
    name: "priceRepeater",
    value: initialValues?.priceRepeater || null,
    inputs: [
      {
        type: "TEXT",
        label: "Slab",
        id: "slab",
        name: "slab",
        placeholder: "Enter the Slab",
        size: 2,
      },
      {
        type: "TEXT",
        label: "Price",
        id: "price",
        name: "price",
        placeholder: "Enter the Price",
        size: 2,
      },
    ],
  },
  {
    groupName: "Search Alias",
    // groupClass: "col-md-12",
    type: "FORM_REPEATER",
    validations: [],
    name: "aliasRepeater",
    value: initialValues?.aliasRepeater || null,
    inputs: [
      {
        type: "TEXT",
        label: "Search Alias",
        id: "search_alias",
        name: "search_alias",
        placeholder: "Enter the Search Alias",
        size: 2,
      },
    ],
  },
  
];
